// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GKag","newExpiryDate":"styles_newExpiryDate__3FhpZ","footer":"styles_footer__Pr556"};